import React, { useState, useEffect } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getter } from "@progress/kendo-react-common";
import NewNote from "../../Popups/NewNote";
import { loadClientNoteGridData } from "../../../handlers/ClientDetail/GridApiCall";
import { DisplayMsg } from "../../../services/toastService";

import useReloadButton from "../../../CustomHooks/useReloadButton";

import { useKendoGridHandlers } from "../../../CustomHooks/useKendoGridHandlers";
import { setUrl } from "../../../handlers";

const DATA_ITEM_KEY = "SEQ_NUM";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

export const DEFAULT_GRID_INFO_CLIENT_NOTE = {
  action: "LOADALLNOTES",
  className: "NOTES",
  pageSize: 20,
  currentPageNumber: 1,
  sortName: "ASSIGNED_TO",
  sortOrder: "desc",
  gridHeight: "300px",
};

const PAGER_SETTINGS = {
  info: true,
  type: "input",
  previousNext: true,
  pageSize: 4,
  refresh: true,
};

const KendoClientDetailNote = (props) => {
  const { noteType, clientId } = props;
  const [gridData, setGridData] = useState([]);
  const [total, setTotal] = useState(0);
  const [popupNote, setPopupNote] = useState(false);
  const [reloadToggle, setReloadToggle] = useState(false);

  const [gridState, setGridState] = useState({
    pageNumber: DEFAULT_GRID_INFO_CLIENT_NOTE.currentPageNumber,
    pageSize: DEFAULT_GRID_INFO_CLIENT_NOTE.pageSize,
    sortName: DEFAULT_GRID_INFO_CLIENT_NOTE.sortName,
    sortOrder: DEFAULT_GRID_INFO_CLIENT_NOTE.sortOrder,
    sort: [
      {
        field: DEFAULT_GRID_INFO_CLIENT_NOTE.sortName,
        dir: DEFAULT_GRID_INFO_CLIENT_NOTE.sortOrder?.toLowerCase() || "asc",
      },
    ],
  });

  const { HandleDataStateChange, HandlePageChange } =
    useKendoGridHandlers(setGridState);

  const [NoteData, setNoteData] = useState({
    attachFiles: null,
    noteDetails: null,
  });

  const [selectedState, setSelectedState] = React.useState();
  // UseEffect to load the grid data
  useEffect(() => {
    loadClientNoteGridData(noteType, clientId, gridState).then((response) => {
      setGridData(response.rows);
      setTotal(response.total);
    });
  }, [noteType, gridState, reloadToggle]);

  useReloadButton(setReloadToggle);
  const SelectedContentLength = () => {
    const selectedText = window.getSelection().toString();
    return selectedText.length > 0;
  };

  const onSelectionChange = React.useCallback(
    (event) => {
      const check = SelectedContentLength();
      if (!check) {
        const newSelectedState = getSelectedState({
          event,
          selectedState,
          dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);
      }
    },
    [selectedState]
  );

  const ShowNotePopup = (NoteDetail) => {
    LoadNoteDetail(NoteDetail);
  };

  const LoadNoteDetail = async (item) => {
    const noteData = new FormData();
    noteData.append("seqNum", item.SEQ_NUM);
    document.getElementById("loader").style.display = "block";
    fetch(setUrl("NOTES", "LOADDETAIL", true), {
      method: "POST",
      body: noteData,
    })
      .then((response) => response.json())
      .then((result) => {
        setNoteData((prevState) => ({
          ...prevState,
          attachFiles: result.AttachmentsData,
          noteDetails: result.Data[0],
        }));

        setPopupNote(!popupNote);
        document.getElementById("loader").style.display = "none";
      })
      .catch((error) => {
        DisplayMsg("2", "Unable to Process the Request...");
      });
  };

  const ShowNoteDetail = (props) => (
      <td className="Comments30" onClick={() => ShowNotePopup(props.dataItem)}>
        <span className="hover:text-black-alpha-80 hover:underline text-blue-600 text-capitalize textWrap cursor-pointer">
          {props.dataItem.SEQ_NUM}
        </span>
      </td>
    );

  const MakeDateField = (props) => {
    const DateString = props.dataItem[props.field];
    let formattedDate = "";
    if (DateString) {
      const parsedDate = new Date(DateString);
      if (!isNaN(parsedDate)) {
        formattedDate = parsedDate.toLocaleDateString("en-US"); // e.g. MM/DD/YYYY
      }
    }
    return <td className="pl-4">{formattedDate}</td>;
  };

  const typeMap = {
    K: "Kick Off Call",
    I: "Implementation Package",
    T: "Training",
    O: "Other",
    "": "",
  };

  const TypeField = (props) => {
    const { TYPE } = props.dataItem;
    const label = typeMap[TYPE] ?? "Unknown";

    return (
      <td className="pl-4">
        <span className="w-75">{label}</span>
      </td>
    );
  };

  const ResolvedField = (props) => {
    if (props.dataItem.RESOLVED === "N") {
      return (
        <td className="pl-4">
          <span className="w-75">No</span>
        </td>
      );
    } if (props.dataItem.RESOLVED === "Y") {
      return (
        <td className="pl-4">
          <span className="w-75">Yes</span>
        </td>
      );
    }
  };

  const HandleSetNote = (childData) => {
    if (childData.render === true) {
      // LoadData();
      setReloadToggle(!reloadToggle);
    }
    setPopupNote(false);
  };

  return (
    <>
      {popupNote ? (
        <NewNote type="detail" parentCallback={HandleSetNote} data={NoteData} />
      ) : (
        ""
      )}
      <div>
        <Tooltip openDelay={100} position="right" anchorElement="target">
          <Grid
            style={{ height: "calc(100vh - 217px)" }}
            scrollable="scrollable"
            total={total}
            skip={(gridState.pageNumber - 1) * gridState.pageSize}
            pageSize={gridState.pageSize}
            filterable={false}
            sortable={{
              mode: "single",
              allowUnsort: false,
            }}
            sort={gridState.sort}
            selectedField={SELECTED_FIELD}
            data={gridData.map((item) => ({
              ...item,
              [SELECTED_FIELD]: selectedState?.[idGetter(item)] || false,
            }))}
            selectable={{
              enabled: true,
              drag: false,
              cell: false,
              mode: "multiple",
            }}
            pageable={PAGER_SETTINGS}
            onPageChange={HandlePageChange}
            onDataStateChange={HandleDataStateChange}
            onSelectionChange={onSelectionChange}
          >
            <GridColumn
              title="Note Key"
              field="SEQ_NUM"
              cell={ShowNoteDetail}
            />
            <GridColumn title="Date" field="NOTE_DATE" cell={MakeDateField} />
            <GridColumn title="Type" field="TYPE" cell={TypeField} />
            <GridColumn title="Comments" field="COMMENTS" />
            <GridColumn
              title="Resolved"
              field="RESOLVED"
              className="ml-4"
              cell={ResolvedField}
            />
            <GridColumn title="Assigned To" field="ASSIGNED_TO" />
            <GridColumn title="Entered By" field="ENTERED_BY" />
            <GridColumn
              title="Entry Date"
              field="ENTRY_DATE"
              className="pl-4"
              cell={MakeDateField}
            />
          </Grid>
        </Tooltip>
      </div>
    </>
  );
};
export default KendoClientDetailNote;
